/* SEAMS: full-width ADD TO BAG bar on product cards.
   Approved code exception (20 Aug notes). Adds straight to cart and opens the cart drawer. */
(function () {
  if (window.__seamsAddToBag) return;
  window.__seamsAddToBag = true;

  /* While an add is on its way, an empty bag says "Adding to bag…" */
  const style = document.createElement('style');
  style.textContent =
    'html[data-seams-adding] .cart-drawer--empty .cart-drawer__content > * { visibility: hidden; }' +
    'html[data-seams-adding] .cart-drawer--empty .cart-drawer__content::after {' +
    ' content: "Adding to bag\\2026"; position: absolute; inset: 0; display: grid; place-items: center;' +
    ' font-size: 0.9rem; letter-spacing: 0.08em; text-transform: uppercase; }' +
    'html[data-seams-adding] .cart-drawer--empty .cart-drawer__content { position: relative; }';
  document.head.appendChild(style);

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-seams-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    /* data-qty lets one button add several — the sanitiser's 3 for 2 (Karen, 22 Sep) */
    const qty = Number(btn.getAttribute('data-qty')) > 0 ? Number(btn.getAttribute('data-qty')) : 1;
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ADDING…';

    /* Open the bag at once, so the click answers straight away; the item drops
       in as soon as Shopify has added it, about half a second later. While the
       bag is still empty it says "Adding to bag…" instead of "Your cart is
       empty" (Karen, 14 Oct: "a little slow"). */
    const root = document.documentElement;
    root.setAttribute('data-seams-adding', '');
    const drawer = document.querySelector('cart-drawer-component')?.closest('theme-drawer');
    if (drawer && !drawer.isOpen && typeof drawer.open === 'function') drawer.open();

    /* The theme's own cart event, as the product page sends it: the bag drawer
       opens, and the drawer and bag count redraw once the add has landed.
       A plain CustomEvent added the item silently (Karen, 10 Oct). */
    let events = null;
    try {
      events = await import('@shopify/events');
    } catch (importErr) { /* the add still works, the drawer just won't open */ }
    const deferred = events ? events.CartLinesUpdateEvent.createPromise() : null;
    if (events) {
      btn.dispatchEvent(
        new events.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity: qty }],
          promise: deferred.promise
        })
      );
    }

    try {
      const sections = [...document.querySelectorAll('cart-items-component')]
        .map(function (el) { return el.dataset.sectionId; })
        .filter(Boolean);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: qty }],
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      });
      if (!res.ok) throw new Error('add failed');
      const json = await res.json();

      if (deferred) {
        const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        deferred.resolve({
          cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { sections: json.sections, itemCount: cart.item_count, source: 'seams-add-to-bag' }
        });
      }

      btn.textContent = 'ADDED';
    } catch (err) {
      if (deferred) deferred.reject(err);
      btn.textContent = 'TRY AGAIN';
    }
    /* Give the bag a moment to redraw with the item before the empty text can show again */
    setTimeout(function () {
      root.removeAttribute('data-seams-adding');
    }, 400);

    setTimeout(function () {
      btn.textContent = label;
      btn.disabled = false;
    }, 1500);
  });
})();

/* SEAMS: CHECKOUT button on product pages — adds the selected variant, then goes to checkout.
   It sends the product form itself, so a Subscribe & Save choice (selling_plan)
   comes along, and it skips the add when that exact line is already in the bag,
   so Add to bag followed by CHECKOUT no longer buys two. */
(function () {
  if (window.__seamsCheckout) return;
  window.__seamsCheckout = true;

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-seams-checkout]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    /* The buy-buttons form, not the first /cart/add form on the page: that one
       is Shop Pay's instalments box in the price block, which has no quantity
       and never receives the Subscribe & Save choice. */
    const form =
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form.shopify-product-form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]:not(.payment-terms)');
    const data = form ? new FormData(form) : new FormData();
    if (!data.get('id') && btn.getAttribute('data-variant-id')) data.set('id', btn.getAttribute('data-variant-id'));
    if (!(Number(data.get('quantity')) > 0)) data.set('quantity', '1');
    const variantId = Number(data.get('id'));
    const plan = data.get('selling_plan') ? Number(data.get('selling_plan')) : null;
    if (!variantId) return;

    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ONE MOMENT…';
    try {
      /* If the bag can't be read (network, rate limit), don't block checkout:
         fall back to adding the item, as the button always did. */
      let already = false;
      try {
        const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (r.ok) {
          const cart = await r.json();
          already = (cart.items || []).some(function (item) {
            const itemPlan = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : null;
            return item.variant_id === variantId && itemPlan === plan;
          });
        }
      } catch (lookupErr) { /* keep already = false */ }
      if (!already) {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
        if (!res.ok) throw new Error('add failed');
      }
      /* Launch gift: let it land in the bag before checkout (never wait more than 3s) */
      if (window.SEAMSGift) {
        await Promise.race([window.SEAMSGift.sync(), new Promise((resolve) => setTimeout(resolve, 3000))]);
      }
      window.location.href = '/checkout';
    } catch (err) {
      btn.textContent = label;
      btn.disabled = false;
    }
  });
})();
